module.exports = __webpack_public_path__ + "static/img/LOGO.c34fdeea.png";